import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../services/content/business.lib.js";
import { FIND_A_WAREHOUSE_DEVELOPEMENT_KEY } from "../../../utils/warehouses/warehouseDrawer.constants.js";
import { FindAWarehouseFormUI } from "./FindAWarehouseFormUI/index.js";
const FindAWarehouseForm = async (props) => {
  const moduleSettings = await getConfigurationSettingByDeveloperKey(
    ContentType.ModuleSettings,
    FIND_A_WAREHOUSE_DEVELOPEMENT_KEY,
    props.locale
  );
  if (!moduleSettings) return null;
  return /* @__PURE__ */ jsx(FindAWarehouseFormUI, { moduleSettings, ...props });
};
export {
  FindAWarehouseForm
};
